/**
 * Method to format a given string in kebab case
 * @param str
 * @returns string | void
 */
export const kebabCaseString = (str: string) => {
  if (str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase();
  }
};

/**
 * Method to parse the incoming text and return the number of instances of a specified character
 * @param text
 * @retuns int
 */
export const parseCharacter = (text: string, char = '#') => {
  if (!text) return 0;

  const pattern = `\\${char}\\w+`;
  const regex = new RegExp(pattern, 'g');
  const items = text.match(regex);

  return items ? items.length : 0;
};
